import { Text, TextAlignment, TokenTextAppearance, TokenTextColor } from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React, { useEffect } from 'react';
import { scrollToTop } from '../../helpers/form-helpers';
import { Section } from './section';

const defaultTitle = 'Tus datos se han enviado correctamente';
const defaultText = 'Muy pronto nos pondremos en contacto contigo.';

interface ScreenProps {
	title?: React.ReactNode;
	text?: React.ReactNode;
	ctas?: React.ReactNode[];
	legal?: React.ReactNode;
	align?: string;
}

export const ThankyouScreen = (props: ScreenProps) => {
	const { title, text, ctas, legal, align } = props;

	useEffect(() => {
		scrollToTop();
		setTimeout(scrollToTop, 1000);
	}, []);

	const textAlign =
		align === 'left' ? TextAlignment.left : align === 'right' ? TextAlignment.right : TextAlignment.center;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignContent: align ? align : 'center',
				gap: '20px',
				padding: '0 15%',
				height: 'calc(100vh - 80px - var(--size-dynamic0270) - var(--size-dynamic0100))',
			}}
		>
			<div style={{ transform: 'scale(2)', transformOrigin: align ? align : 'center' + ' center' }}>
				<Checkmark variant="default" />
			</div>
			{title || (
				<Text appearance={TokenTextAppearance.headline300} textAlign={textAlign} bold>
					{defaultTitle}
				</Text>
			)}
			{text || (
				<Text appearance={TokenTextAppearance.copy100} textAlign={textAlign}>
					{defaultText}
				</Text>
			)}
			{ctas &&
				ctas.map((cta, index) => (
					<div className="cta" key={index} style={{ marginTop: '10px', textAlign: align ? align : ('center' as any) }}>
						{cta}
					</div>
				))}
			{legal && (
				<div style={{ marginTop: '80px' }}>
					<Text appearance={TokenTextAppearance.copy100} textAlign={textAlign} color={TokenTextColor.secondary}>
						{legal}
					</Text>
				</div>
			)}
		</div>
	);
};

interface SectionProps {
	title?: string;
	text?: string;
	align?: string;
	height?: string;
}

export const ThankyouSection = (props: SectionProps) => {
	const { title, text, align, height } = props;
	return (
		<Section>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: align ? align : 'center',
					alignItems: 'center',
					height: height ? height : 'auto',
				}}
			>
				<Checkmark variant="default" />
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
					{title || defaultTitle}
				</Text>
				<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
					{text || defaultText}
				</Text>
			</div>
		</Section>
	);
};
